import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';   
import { map } from 'rxjs/operators';
import { FnToasterService } from '../../toaster/index'; 
import { FnGridActionSetup } from '../model/fn-grid-action.setup'; 
import { FnGridColumn } from '../model/fn-grid-column';
import { FnGridRow } from '../model/fn-grid-row';
import { FnGridGlobalService } from './fn-grid-global.service';
@Injectable()
export class FnGridService {
    private actionSetupMap:any = {} ; //{key: FnTableAction}
    
    constructor(private fnGridGlobalSvcs:FnGridGlobalService, private httpClient:HttpClient, private fnToastSvcs:FnToasterService){
        
    }

	buildTableActionMap(actionSetupArray: Array<FnGridActionSetup>) {
      
        
		const _size = actionSetupArray.length;
		for (let i = 0; i < _size; i++) {
			const _tableAction = actionSetupArray[i];
			this.actionSetupMap[_tableAction.typeID] = _tableAction;
		}
	}

	getActionMapForId(id: string):FnGridActionSetup {
		return this.actionSetupMap[id];
    }
    

     gridApiPostAction(cellVal:any,rowData:FnGridRow|any,colData:FnGridColumn,uniqueKey:any){
        let baseUrl = this.fnGridGlobalSvcs.getPostApiUrl();
        const gridActionSetup = this.getActionMapForId(colData.actionSetupID);
        let reqMap:any = {
            selectedObjectHash: this.fnGridGlobalSvcs.getFnAppSession(),
            queryParamHash: this.fnGridGlobalSvcs.getQueryParamHash(),
            objectHash:{}
        };
        reqMap.objectHash[colData.field] = cellVal;
        reqMap.objectHash[uniqueKey]= rowData[uniqueKey];
       

       return this.httpClient.post(baseUrl+gridActionSetup.actionID,reqMap).pipe(
			map((response:any) => {
				if (!response.responseMsg.isError) {
                    this.fnToastSvcs.error("Action performed successfully!", 'Success');
                    return response.responseResult.result.data;                    
				} else {
					this.fnToastSvcs.error("Problem process data on server", 'Error');
					return null;
				}
			})
		);

     }
}
